/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 14.05.17.
 */

import React from 'react';
import PropTypes from 'prop-types';

import CONFIG from "../../config";
import Notify from '../../containers/Notify';
import Password from "../../containers/Password";
import {t} from "../../trans";

const propTypes = {
    /**
     * Initial dialog:
     *  password - show password form
     *  authcode - show two-factor authenticator code form
     *  forgot - show forgot password form
     */
    dialog: PropTypes.string,
    /**
     * If true - show form on disabled state
     */
    inProgress: PropTypes.bool,
    /**
     * Default value for e-mail address field
     */
    email: PropTypes.string,
    /**
     * Callback function called when the user clicks to "Login" button in Password form.
     * Signature:
     *      onLogin(type, username, password, code)
     */
    onLogin: PropTypes.func,
    /**
     * Callback function called when the user clicks to "Cancel" button.
     * Signature:
     *      onCancel();
     */
    onCancel: PropTypes.func,
    /**
     * Callback function called when the user clicks to "Forgot password" link.
     * Signature:
     *      onForgot(username)
     */
    onForgot: PropTypes.func
};

const defaultProps = {
    inProgress: false
};

class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let {children, ...props} = this.props;
        return (
            <div className="gray-bg" style={{position: "relative", minHeight: "100%"}}>
                <div className="middle-box text-center loginscreen animated fadeInDown">
                    <Password {...props}/>
                    <p className="m-t">
                        <small>{t(CONFIG.copyright)}</small>
                    </p>
                </div>
                {children}
                <Notify/>
            </div>
        );
    }
}

LoginPage.propTypes = propTypes;
LoginPage.defaultProps = defaultProps;

export default LoginPage;
